export default __webpack_public_path__ + "static/media/empty-user.cf3aa341.svg";